import { z } from '@customerio/hydra-validation';

/**
 * Parses an epoch-seconds timestamp that the wire may send as `number | null`
 * (or omit) — e.g. `last_used_at` for a credential/IP that has never been used.
 * A missing value maps to the Unix epoch (`Date(0)`) so callers can render a
 * "Never used" / "Never seen" fallback, rather than the whole list-parse
 * throwing on a null. Use this instead of the non-nullable `epochSecondsToDate`
 * for optional timestamps.
 */
export const nullableEpochSecondsToDate = z
  .number()
  .nullish()
  .transform((seconds) => new Date((seconds ?? 0) * 1000));
